// Central plan-gate helper. Every paid tier at or above "pro" gets all pro features.
// Add a new tier: extend PRO_PLANS. Do not scatter plan comparisons across components.

export const PRO_PLANS = new Set(["pro", "max"] as const);

export type ProPlan = "pro" | "max";
export type AnyPlan = string | null | undefined;

export function isProPlan(plan: AnyPlan): boolean {
  return typeof plan === "string" && PRO_PLANS.has(plan as ProPlan);
}

// AI flashcard generation is Max-only. This deliberately does NOT reuse
// isProPlan: FLASHCARD_LIMITS in backend/flashcards/router.py gives pro a
// quota of 0, so treating pro as entitled here would unlock the UI and
// then 403 on generate. Study passes resolve to max (backend/plans.py
// _pass_plan), so pass holders are covered. Keep this in step with
// FLASHCARD_LIMITS; the backend remains the enforcement boundary.
export function canGenerateFlashcards(plan: AnyPlan): boolean {
  return plan === "max";
}
